import React, {useContext, useEffect} from 'react';
import classNames from 'classnames';
import {PathDesignContext} from 'src/components/path-design-context';
import Icon from 'shared/components/icon';
import CarouselArrow from 'shared/components/carousel-arrow';
import MQ from 'shared/media-query';
import 'stylesheets/components/college-profile/college-images-lightbox.scss';

interface Props {
  image: React.ReactNode;
  changeLightboxPage: (direction: number) => () => void;
  handleClose: () => void;
  currentPage: number;
  imageCount?: number;
  name?: string;
}

const CollegeImagesLightbox = ({
  image,
  changeLightboxPage,
  handleClose,
  currentPage,
  imageCount = 0,
  name,
}: Props) => {
  const path = useContext(PathDesignContext);

  const keyHandler = (e) => {
    if (e.key === 'ArrowRight' && currentPage !== imageCount - 1) {
      changeLightboxPage(1)();
    } else if (e.key === 'ArrowLeft' && currentPage !== 0) {
      changeLightboxPage(-1)();
    }
  };

  useEffect(() => {
    document.addEventListener('keydown', keyHandler, {capture: true});
    return () => {
      document.removeEventListener('keydown', keyHandler, {capture: true});
    };
  }, []);

  return (
    <div
      className={classNames('college-photos-lightbox', {['--path']: path.enabled})}
      data-testid="images-lightbox"
    >
      <div className="college-photos-lightbox-exit">
        <Icon className="lightbox-icon" onClick={handleClose} iconType="times-r" />
      </div>
      <div className="college-photos-lightbox-content-container">
        <div className="college-photos-lightbox-photo">{image}</div>
        <div className="lightbox-navigation">
          <div className="lightbox-info">
            <span className="lightbox-info-title">
              <Icon iconType="instagram" /> {name}
            </span>
            <span className="lightbox-info-pageCount">{`${currentPage + 1} of ${imageCount}`}</span>
          </div>
          <MQ.MS_AND_DOWN>
            <hr />
          </MQ.MS_AND_DOWN>
          <div className="college-photos-lightbox-controls">
            {currentPage !== 0 ? (
              <>
                <MQ.MS_AND_DOWN>
                  <Icon
                    className="lightbox-icon"
                    iconType="chevron-left"
                    onClick={changeLightboxPage(-1)}
                  />
                </MQ.MS_AND_DOWN>
                <MQ.SM_AND_UP>
                  <CarouselArrow
                    className="college-photos-lightbox-controls-arrow"
                    direction="left"
                    arrowKey={currentPage}
                    onClick={changeLightboxPage(-1)}
                  />
                </MQ.SM_AND_UP>
              </>
            ) : (
              <span>&nbsp;</span>
            )}
            {currentPage !== imageCount - 1 && (
              <>
                <MQ.MS_AND_DOWN>
                  <Icon
                    className="lightbox-icon"
                    iconType="chevron-right"
                    onClick={changeLightboxPage(1)}
                  />
                </MQ.MS_AND_DOWN>
                <MQ.SM_AND_UP>
                  <CarouselArrow
                    className="college-photos-lightbox-controls-arrow"
                    direction="right"
                    arrowKey={currentPage}
                    onClick={changeLightboxPage(1)}
                  />
                </MQ.SM_AND_UP>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CollegeImagesLightbox;
